import { GithubAuthBtn } from '@playbooks/components/github/github-auth-btn';
import { GoogleAuthBtn } from '@playbooks/components/google/google-auth-btn';

const AuthProviderActions = ({ compact = false, onNext }) => {
	// Render
	return compact ? (
		<div className='grid grid-cols-2 gap-2'>
			<GoogleAuthBtn variant='outline' size='default' onNext={onNext}>
				Google
			</GoogleAuthBtn>
			<GithubAuthBtn variant='outline' size='default' onNext={onNext}>
				GitHub
			</GithubAuthBtn>
		</div>
	) : (
		<div className='flex-column gap-2'>
			<GoogleAuthBtn variant='outline' onNext={onNext} />
			<GithubAuthBtn variant='outline' onNext={onNext} />
		</div>
	);
};

export { AuthProviderActions };
